import { NewsCategory } from "app/pages/sales-intelligence/sub-modules/signals/models/news/NewsCategory";

import type { NewsSignalEventDto } from "../../../types/signals";

export const LEARN_MORE_TEXT = "Get insights about";

type SignalTextMapFunc = (signal: NewsSignalEventDto, companyName?: string) => string;

const getSignalEventTitle: SignalTextMapFunc = ({ title }) => title;

export const signalTitleTextMap: Record<NewsCategory, SignalTextMapFunc | string> = {
    [NewsCategory.Hires]: ({ jobTitle = "" }, companyName) => `${companyName} hired ${jobTitle}`,
    [NewsCategory.Promotes]: ({ jobTitle = "" }, companyName) => `${companyName} promoted ${jobTitle}`,
    [NewsCategory.Leaves]: ({ jobTitle = "" }, companyName) => `${jobTitle} left ${companyName}`,
    [NewsCategory.Retires]: ({ jobTitle = "" }, companyName) => `${jobTitle} left ${companyName}`,
    [NewsCategory.OpensNewLocation]: ({ location = "" }, companyName) =>
        `${companyName} opens new office in ${location}`,
    [NewsCategory.ExpandsOfficesIn]: getSignalEventTitle,
    [NewsCategory.ExpandsOfficesTo]: getSignalEventTitle,
    [NewsCategory.ExpandsFacilities]: getSignalEventTitle,
    [NewsCategory.SignsNewClient]: getSignalEventTitle,
    [NewsCategory.IncreasesHeadcountBy]: getSignalEventTitle,
    [NewsCategory.AttendsEvent]: getSignalEventTitle,
    [NewsCategory.Acquires]: getSignalEventTitle,
    [NewsCategory.MergesWith]: getSignalEventTitle,
    [NewsCategory.Launches]: getSignalEventTitle,
    [NewsCategory.IntegratesWith]: getSignalEventTitle,
    [NewsCategory.IsDeveloping]: getSignalEventTitle,
    [NewsCategory.PartnersWith]: getSignalEventTitle,
    [NewsCategory.EndsPartnershipWith]: getSignalEventTitle,
    [NewsCategory.SellsAssetsTo]: getSignalEventTitle,
    [NewsCategory.IdentifiedAsCompetitorOf]: getSignalEventTitle,
    [NewsCategory.SpinsOffCompany]: getSignalEventTitle,
    [NewsCategory.SpinsOffDivision]: getSignalEventTitle,
    [NewsCategory.ReceivesFinancing]: getSignalEventTitle,
    [NewsCategory.InvestsInto]: getSignalEventTitle,
    [NewsCategory.InvestsIntoAssets]: getSignalEventTitle,
    [NewsCategory.GoesPublic]: (_, companyName) => `${companyName} is going public (IPO)`,
    [NewsCategory.HasEarnings]: getSignalEventTitle,
    [NewsCategory.HasRevenue]: getSignalEventTitle,
    [NewsCategory.HasValuation]: getSignalEventTitle,
    [NewsCategory.ClosesOffices]: getSignalEventTitle,
    [NewsCategory.DecreasesHeadcountBy]: getSignalEventTitle,
    [NewsCategory.FilesSuitAgainst]: getSignalEventTitle,
    [NewsCategory.HasIssuesWith]: getSignalEventTitle,
    [NewsCategory.DeclaresBankruptcy]: getSignalEventTitle,
    [NewsCategory.LosesClient]: getSignalEventTitle,
    [NewsCategory.ReceivesAward]: getSignalEventTitle,
    [NewsCategory.RecognizedAs]: getSignalEventTitle,
};

export const signalInfoTextMap: Record<NewsCategory, SignalTextMapFunc | string> = {
    [NewsCategory.Hires]: getSignalEventTitle,
    [NewsCategory.Promotes]: getSignalEventTitle,
    [NewsCategory.Leaves]: getSignalEventTitle,
    [NewsCategory.Retires]: getSignalEventTitle,
    [NewsCategory.OpensNewLocation]: "",
    [NewsCategory.ExpandsOfficesIn]: "",
    [NewsCategory.ExpandsOfficesTo]: "",
    [NewsCategory.ExpandsFacilities]: "",
    [NewsCategory.SignsNewClient]: LEARN_MORE_TEXT,
    [NewsCategory.IncreasesHeadcountBy]: ({ articleSentence = "" }) => articleSentence,
    [NewsCategory.AttendsEvent]: "",
    [NewsCategory.Acquires]: LEARN_MORE_TEXT,
    [NewsCategory.MergesWith]: LEARN_MORE_TEXT,
    [NewsCategory.Launches]: "",
    [NewsCategory.IntegratesWith]: LEARN_MORE_TEXT,
    [NewsCategory.IsDeveloping]: "",
    [NewsCategory.PartnersWith]: LEARN_MORE_TEXT,
    [NewsCategory.EndsPartnershipWith]: LEARN_MORE_TEXT,
    [NewsCategory.SellsAssetsTo]: LEARN_MORE_TEXT,
    [NewsCategory.IdentifiedAsCompetitorOf]: LEARN_MORE_TEXT,
    [NewsCategory.SpinsOffCompany]: LEARN_MORE_TEXT,
    [NewsCategory.SpinsOffDivision]: LEARN_MORE_TEXT,
    [NewsCategory.ReceivesFinancing]: "",
    [NewsCategory.InvestsInto]: LEARN_MORE_TEXT,
    [NewsCategory.InvestsIntoAssets]: "",
    [NewsCategory.GoesPublic]: "",
    [NewsCategory.HasEarnings]: "",
    [NewsCategory.HasRevenue]: "",
    [NewsCategory.HasValuation]: "",
    [NewsCategory.ClosesOffices]: "",
    [NewsCategory.DecreasesHeadcountBy]: ({ articleSentence = "" }) => articleSentence,
    [NewsCategory.FilesSuitAgainst]: LEARN_MORE_TEXT,
    [NewsCategory.HasIssuesWith]: "",
    [NewsCategory.DeclaresBankruptcy]: "",
    [NewsCategory.LosesClient]: LEARN_MORE_TEXT,
    [NewsCategory.ReceivesAward]: "",
    [NewsCategory.RecognizedAs]: "",
};
